import { render, staticRenderFns } from "./DownloadLicense.vue?vue&type=template&id=01d243a4&scoped=true&lang=pug"
import script from "./DownloadLicense.vue?vue&type=script&lang=js"
export * from "./DownloadLicense.vue?vue&type=script&lang=js"
import style0 from "./DownloadLicense.vue?vue&type=style&index=0&id=01d243a4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d243a4",
  null
  
)

export default component.exports